export default "__VITE_ASSET__d0972e57__"